// extracted by mini-css-extract-plugin
export default {"button":"Po-z","reviewSort":"Qo-z"};